import React from 'react';

const ModalContext = React.createContext({ closeModal: console.error });

export default ModalContext;
